module.exports = __webpack_public_path__ + "img/jewel.acdd9d34.png";